import useQuery from '../../../hooks/useQuery';

export default function LoginFailure() {
  const query = useQuery();
  return (
    <>
      <h1>Login Failure</h1>
      {query.get('description')}
    </>
  );
}
